import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoData = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 418.093,
	height: 189.283,
	viewBox: "0 0 418.093 189.283",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_2982",
		"data-name": "Group 2982",
		transform: "translate(-276.667 -352.508)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2510",
				"data-name": "Path 2510",
				d: "M659.556,450.666A123.652,123.652,0,0,1,616.4,409a94.576,94.576,0,0,0-106.277-41.221,93.212,93.212,0,0,1-65.888-5.992,94.965,94.965,0,0,0-57.443-7.867,93.487,93.487,0,0,0-76.148,74.8q-.065.344-.127.688a78.489,78.489,0,0,1-20.367,39.86,49.432,49.432,0,0,0,5.046,72.52H688.106a70.75,70.75,0,0,0-28.55-91.125Z",
				fill: "#f7e7f2"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2966",
				"data-name": "Group 2966",
				transform: "translate(634.975 508.044)",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_2511",
					"data-name": "Path 2511",
					d: "M2343.786,1244.3l-12.711,33.747H2356.5Z",
					transform: "translate(-2331.075 -1244.297)",
					fill: "#fff"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_2512",
					"data-name": "Path 2512",
					d: "M2386.715,1329.68l2.807,2.807.525-.526-3.332-3.332v-6.35h-.743v2.039l-3.349,3.349.525.526,2.824-2.824v7.537l-3.349,3.349.525.526,2.824-2.824v8.469h.743v-4.972l2.807,2.807.525-.526-3.332-3.332Z",
					transform: "translate(-2373.632 -1308.678)",
					fill: "#ec6786"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2967",
				"data-name": "Group 2967",
				transform: "translate(607.541 496.651)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2513",
						"data-name": "Path 2513",
						d: "M2190.785,1178.974l-17,45.14h34.005Z",
						transform: "translate(-2173.782 -1178.974)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_831",
						"data-name": "Rectangle 831",
						width: .994,
						height: 26.948,
						transform: "translate(16.506 18.192)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_832",
						"data-name": "Rectangle 832",
						width: .994,
						height: 6.468,
						transform: "translate(12.728 26.103) rotate(-135)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_833",
						"data-name": "Rectangle 833",
						width: .994,
						height: 6.468,
						transform: "matrix(-0.707, -0.707, 0.707, -0.707, 12.728, 37.59)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_834",
						"data-name": "Rectangle 834",
						width: .994,
						height: 6.468,
						transform: "matrix(-0.707, 0.707, -0.707, -0.707, 21.957, 31.143)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_835",
						"data-name": "Rectangle 835",
						width: .994,
						height: 6.468,
						transform: "matrix(-0.707, 0.707, -0.707, -0.707, 21.957, 41.541)",
						fill: "#2e2b60"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2968",
				"data-name": "Group 2968",
				transform: "translate(552.427 354.312)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_836",
						"data-name": "Rectangle 836",
						width: 66.73,
						height: 176.979,
						transform: "translate(0 10.501)",
						fill: "#7284fa"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_837",
						"data-name": "Rectangle 837",
						width: 8.296,
						height: 8.296,
						transform: "translate(34.333 36.713)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_838",
						"data-name": "Rectangle 838",
						width: 8.296,
						height: 8.296,
						transform: "translate(34.333 69.764)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_839",
						"data-name": "Rectangle 839",
						width: 8.296,
						height: 8.296,
						transform: "translate(34.333 102.815)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_840",
						"data-name": "Rectangle 840",
						width: 8.296,
						height: 8.296,
						transform: "translate(34.333 135.866)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_841",
						"data-name": "Rectangle 841",
						width: 8.296,
						height: 8.296,
						transform: "translate(49.515 20.188)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_842",
						"data-name": "Rectangle 842",
						width: 8.296,
						height: 8.296,
						transform: "translate(49.515 53.238)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_843",
						"data-name": "Rectangle 843",
						width: 8.296,
						height: 8.296,
						transform: "translate(49.515 86.289)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_844",
						"data-name": "Rectangle 844",
						width: 8.296,
						height: 8.296,
						transform: "translate(49.515 119.34)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_845",
						"data-name": "Rectangle 845",
						width: 8.59,
						height: 13.227,
						transform: "translate(33.365)",
						fill: "#7284fa"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_846",
						"data-name": "Rectangle 846",
						width: 8.59,
						height: 13.227,
						transform: "translate(57.811 7.345) rotate(90)",
						fill: "#7284fa"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2969",
				"data-name": "Group 2969",
				transform: "translate(369.446 361.34)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_847",
						"data-name": "Rectangle 847",
						width: 4.295,
						height: 15.907,
						transform: "translate(23.473 0)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_848",
						"data-name": "Rectangle 848",
						width: 4.295,
						height: 15.907,
						transform: "translate(29.942 0)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_849",
						"data-name": "Rectangle 849",
						width: 10.516,
						height: 15.907,
						transform: "translate(69.038 10.235) rotate(90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_850",
						"data-name": "Rectangle 850",
						width: 93.739,
						height: 164.959,
						transform: "translate(0 15.493)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_851",
						"data-name": "Rectangle 851",
						width: 6.215,
						height: 6.215,
						transform: "translate(78.264 32.924) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_852",
						"data-name": "Rectangle 852",
						width: 6.215,
						height: 6.215,
						transform: "translate(66.698 32.924) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_853",
						"data-name": "Rectangle 853",
						width: 6.215,
						height: 6.215,
						transform: "translate(55.132 32.924) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_854",
						"data-name": "Rectangle 854",
						width: 6.215,
						height: 6.215,
						transform: "translate(43.566 32.924) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_855",
						"data-name": "Rectangle 855",
						width: 6.215,
						height: 6.215,
						transform: "translate(32 32.924) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_856",
						"data-name": "Rectangle 856",
						width: 6.215,
						height: 6.215,
						transform: "translate(20.433 32.924) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_857",
						"data-name": "Rectangle 857",
						width: 6.215,
						height: 6.215,
						transform: "translate(8.867 32.924) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_858",
						"data-name": "Rectangle 858",
						width: 6.215,
						height: 6.215,
						transform: "translate(78.264 45.098) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_859",
						"data-name": "Rectangle 859",
						width: 6.215,
						height: 6.215,
						transform: "translate(66.698 45.098) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_860",
						"data-name": "Rectangle 860",
						width: 6.215,
						height: 6.215,
						transform: "translate(55.132 45.098) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_861",
						"data-name": "Rectangle 861",
						width: 6.215,
						height: 6.215,
						transform: "translate(43.566 45.098) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_862",
						"data-name": "Rectangle 862",
						width: 6.215,
						height: 6.215,
						transform: "translate(32 45.098) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_863",
						"data-name": "Rectangle 863",
						width: 6.215,
						height: 6.215,
						transform: "translate(20.433 45.098) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_864",
						"data-name": "Rectangle 864",
						width: 6.215,
						height: 6.215,
						transform: "translate(8.867 45.098) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_865",
						"data-name": "Rectangle 865",
						width: 6.215,
						height: 6.215,
						transform: "translate(78.264 57.271) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_866",
						"data-name": "Rectangle 866",
						width: 6.215,
						height: 6.215,
						transform: "translate(66.698 57.271) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_867",
						"data-name": "Rectangle 867",
						width: 6.215,
						height: 6.215,
						transform: "translate(55.132 57.271) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_868",
						"data-name": "Rectangle 868",
						width: 6.215,
						height: 6.215,
						transform: "translate(43.566 57.271) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_869",
						"data-name": "Rectangle 869",
						width: 6.215,
						height: 6.215,
						transform: "translate(32 57.271) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_870",
						"data-name": "Rectangle 870",
						width: 6.215,
						height: 6.215,
						transform: "translate(20.433 57.271) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_871",
						"data-name": "Rectangle 871",
						width: 6.215,
						height: 6.215,
						transform: "translate(8.867 57.271) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_872",
						"data-name": "Rectangle 872",
						width: 6.215,
						height: 6.215,
						transform: "translate(78.264 69.445) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_873",
						"data-name": "Rectangle 873",
						width: 6.215,
						height: 6.215,
						transform: "translate(66.698 69.445) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_874",
						"data-name": "Rectangle 874",
						width: 6.215,
						height: 6.215,
						transform: "translate(55.132 69.445) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_875",
						"data-name": "Rectangle 875",
						width: 6.215,
						height: 6.215,
						transform: "translate(43.566 69.445) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_876",
						"data-name": "Rectangle 876",
						width: 6.215,
						height: 6.215,
						transform: "translate(32 69.445) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_877",
						"data-name": "Rectangle 877",
						width: 6.215,
						height: 6.215,
						transform: "translate(20.433 69.445) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_878",
						"data-name": "Rectangle 878",
						width: 6.215,
						height: 6.215,
						transform: "translate(8.867 69.445) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_879",
						"data-name": "Rectangle 879",
						width: 6.215,
						height: 6.215,
						transform: "translate(78.264 81.618) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_880",
						"data-name": "Rectangle 880",
						width: 6.215,
						height: 6.215,
						transform: "translate(66.698 81.618) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_881",
						"data-name": "Rectangle 881",
						width: 6.215,
						height: 6.215,
						transform: "translate(55.132 81.618) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_882",
						"data-name": "Rectangle 882",
						width: 6.215,
						height: 6.215,
						transform: "translate(43.566 81.618) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_883",
						"data-name": "Rectangle 883",
						width: 6.215,
						height: 6.215,
						transform: "translate(32 81.618) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_884",
						"data-name": "Rectangle 884",
						width: 6.215,
						height: 6.215,
						transform: "translate(20.433 81.618) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_885",
						"data-name": "Rectangle 885",
						width: 6.215,
						height: 6.215,
						transform: "translate(8.867 81.618) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_886",
						"data-name": "Rectangle 886",
						width: 6.215,
						height: 6.215,
						transform: "translate(78.264 93.792) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_887",
						"data-name": "Rectangle 887",
						width: 6.215,
						height: 6.215,
						transform: "translate(66.698 93.792) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_888",
						"data-name": "Rectangle 888",
						width: 6.215,
						height: 6.215,
						transform: "translate(55.132 93.792) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_889",
						"data-name": "Rectangle 889",
						width: 6.215,
						height: 6.215,
						transform: "translate(43.566 93.792) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_890",
						"data-name": "Rectangle 890",
						width: 6.215,
						height: 6.215,
						transform: "translate(32 93.792) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_891",
						"data-name": "Rectangle 891",
						width: 6.215,
						height: 6.215,
						transform: "translate(20.433 93.792) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_892",
						"data-name": "Rectangle 892",
						width: 6.215,
						height: 6.215,
						transform: "translate(8.867 93.792) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_893",
						"data-name": "Rectangle 893",
						width: 6.215,
						height: 6.215,
						transform: "translate(78.264 105.966) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_894",
						"data-name": "Rectangle 894",
						width: 6.215,
						height: 6.215,
						transform: "translate(66.698 105.966) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_895",
						"data-name": "Rectangle 895",
						width: 6.215,
						height: 6.215,
						transform: "translate(55.132 105.966) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_896",
						"data-name": "Rectangle 896",
						width: 6.215,
						height: 6.215,
						transform: "translate(43.566 105.966) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_897",
						"data-name": "Rectangle 897",
						width: 6.215,
						height: 6.215,
						transform: "translate(32 105.966) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_898",
						"data-name": "Rectangle 898",
						width: 6.215,
						height: 6.215,
						transform: "translate(20.433 105.966) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_899",
						"data-name": "Rectangle 899",
						width: 6.215,
						height: 6.215,
						transform: "translate(8.867 105.966) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_900",
						"data-name": "Rectangle 900",
						width: 6.215,
						height: 6.215,
						transform: "translate(78.264 118.139) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_901",
						"data-name": "Rectangle 901",
						width: 6.215,
						height: 6.215,
						transform: "translate(66.698 118.139) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_902",
						"data-name": "Rectangle 902",
						width: 6.215,
						height: 6.215,
						transform: "translate(55.132 118.139) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_903",
						"data-name": "Rectangle 903",
						width: 6.215,
						height: 6.215,
						transform: "translate(43.566 118.139) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_904",
						"data-name": "Rectangle 904",
						width: 6.215,
						height: 6.215,
						transform: "translate(32 118.139) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_905",
						"data-name": "Rectangle 905",
						width: 6.215,
						height: 6.215,
						transform: "translate(20.433 118.139) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_906",
						"data-name": "Rectangle 906",
						width: 6.215,
						height: 6.215,
						transform: "translate(8.867 118.139) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_907",
						"data-name": "Rectangle 907",
						width: 6.215,
						height: 6.215,
						transform: "translate(78.264 130.313) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_908",
						"data-name": "Rectangle 908",
						width: 6.215,
						height: 6.215,
						transform: "translate(66.698 130.313) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_909",
						"data-name": "Rectangle 909",
						width: 6.215,
						height: 6.215,
						transform: "translate(55.132 130.313) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_910",
						"data-name": "Rectangle 910",
						width: 6.215,
						height: 6.215,
						transform: "translate(43.566 130.313) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_911",
						"data-name": "Rectangle 911",
						width: 6.215,
						height: 6.215,
						transform: "translate(32 130.313) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_912",
						"data-name": "Rectangle 912",
						width: 6.215,
						height: 6.215,
						transform: "translate(20.433 130.313) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_913",
						"data-name": "Rectangle 913",
						width: 6.215,
						height: 6.215,
						transform: "translate(8.867 130.313) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_914",
						"data-name": "Rectangle 914",
						width: 6.215,
						height: 6.215,
						transform: "translate(78.264 142.486) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_915",
						"data-name": "Rectangle 915",
						width: 6.215,
						height: 6.215,
						transform: "translate(66.698 142.486) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_916",
						"data-name": "Rectangle 916",
						width: 6.215,
						height: 6.215,
						transform: "translate(55.132 142.486) rotate(-90)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_917",
						"data-name": "Rectangle 917",
						width: 6.215,
						height: 6.215,
						transform: "translate(43.566 142.486) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_918",
						"data-name": "Rectangle 918",
						width: 6.215,
						height: 6.215,
						transform: "translate(32 142.486) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_919",
						"data-name": "Rectangle 919",
						width: 6.215,
						height: 6.215,
						transform: "translate(20.433 142.486) rotate(-90)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_920",
						"data-name": "Rectangle 920",
						width: 6.215,
						height: 6.215,
						transform: "translate(8.867 142.486) rotate(-90)",
						fill: "#2e2b60"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2971",
				"data-name": "Group 2971",
				transform: "translate(447.71 395.898)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_921",
						"data-name": "Rectangle 921",
						width: 44.763,
						height: 145.893,
						transform: "translate(0 0)",
						fill: "#ec6786"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_922",
						"data-name": "Rectangle 922",
						width: 38.242,
						height: 1.62,
						transform: "translate(3.26 2.812)",
						fill: "#ab547a"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_923",
						"data-name": "Rectangle 923",
						width: 4.318,
						height: 13.058,
						transform: "translate(5.116 8.81)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_924",
						"data-name": "Rectangle 924",
						width: 4.318,
						height: 13.058,
						transform: "translate(12.669 8.81)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_925",
						"data-name": "Rectangle 925",
						width: 4.318,
						height: 13.058,
						transform: "translate(20.222 8.81)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_926",
						"data-name": "Rectangle 926",
						width: 4.318,
						height: 13.058,
						transform: "translate(27.775 8.81)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_927",
						"data-name": "Rectangle 927",
						width: 4.318,
						height: 13.058,
						transform: "translate(35.329 8.81)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_928",
						"data-name": "Rectangle 928",
						width: 4.318,
						height: 13.058,
						transform: "translate(5.116 25.502)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_929",
						"data-name": "Rectangle 929",
						width: 4.318,
						height: 13.058,
						transform: "translate(12.669 25.502)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_930",
						"data-name": "Rectangle 930",
						width: 4.318,
						height: 13.058,
						transform: "translate(20.222 25.502)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_931",
						"data-name": "Rectangle 931",
						width: 4.318,
						height: 13.058,
						transform: "translate(27.775 25.502)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_932",
						"data-name": "Rectangle 932",
						width: 4.318,
						height: 13.058,
						transform: "translate(35.329 25.502)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_933",
						"data-name": "Rectangle 933",
						width: 4.318,
						height: 13.058,
						transform: "translate(5.116 42.193)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_934",
						"data-name": "Rectangle 934",
						width: 4.318,
						height: 13.058,
						transform: "translate(12.669 42.193)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_935",
						"data-name": "Rectangle 935",
						width: 4.318,
						height: 13.058,
						transform: "translate(20.222 42.193)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_936",
						"data-name": "Rectangle 936",
						width: 4.318,
						height: 13.058,
						transform: "translate(27.775 42.193)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_937",
						"data-name": "Rectangle 937",
						width: 4.318,
						height: 13.058,
						transform: "translate(35.329 42.193)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_938",
						"data-name": "Rectangle 938",
						width: 4.318,
						height: 13.058,
						transform: "translate(5.116 58.885)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_939",
						"data-name": "Rectangle 939",
						width: 4.318,
						height: 13.058,
						transform: "translate(12.669 58.885)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_940",
						"data-name": "Rectangle 940",
						width: 4.318,
						height: 13.058,
						transform: "translate(20.222 58.885)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_941",
						"data-name": "Rectangle 941",
						width: 4.318,
						height: 13.058,
						transform: "translate(27.775 58.885)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_942",
						"data-name": "Rectangle 942",
						width: 4.318,
						height: 13.058,
						transform: "translate(35.329 58.885)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_943",
						"data-name": "Rectangle 943",
						width: 4.318,
						height: 13.058,
						transform: "translate(5.116 75.576)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_944",
						"data-name": "Rectangle 944",
						width: 4.318,
						height: 13.058,
						transform: "translate(12.669 75.576)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_945",
						"data-name": "Rectangle 945",
						width: 4.318,
						height: 13.058,
						transform: "translate(20.222 75.576)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_946",
						"data-name": "Rectangle 946",
						width: 4.318,
						height: 13.058,
						transform: "translate(27.775 75.576)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_947",
						"data-name": "Rectangle 947",
						width: 4.318,
						height: 13.058,
						transform: "translate(35.329 75.576)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_948",
						"data-name": "Rectangle 948",
						width: 4.318,
						height: 13.058,
						transform: "translate(5.116 92.268)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_949",
						"data-name": "Rectangle 949",
						width: 4.318,
						height: 13.058,
						transform: "translate(12.669 92.268)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_950",
						"data-name": "Rectangle 950",
						width: 4.318,
						height: 13.058,
						transform: "translate(20.222 92.268)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_951",
						"data-name": "Rectangle 951",
						width: 4.318,
						height: 13.058,
						transform: "translate(27.775 92.268)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_952",
						"data-name": "Rectangle 952",
						width: 4.318,
						height: 13.058,
						transform: "translate(35.329 92.268)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_2970",
						"data-name": "Group 2970",
						transform: "translate(5.116 108.959)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_953",
								"data-name": "Rectangle 953",
								width: 4.318,
								height: 13.058,
								fill: "#f7e7f2"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_954",
								"data-name": "Rectangle 954",
								width: 4.318,
								height: 13.058,
								transform: "translate(7.553)",
								fill: "#f7e7f2"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_955",
								"data-name": "Rectangle 955",
								width: 4.318,
								height: 13.058,
								transform: "translate(15.106)",
								fill: "#f7e7f2"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_956",
								"data-name": "Rectangle 956",
								width: 4.318,
								height: 13.058,
								transform: "translate(22.659)",
								fill: "#f7e7f2"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_957",
								"data-name": "Rectangle 957",
								width: 4.318,
								height: 13.058,
								transform: "translate(30.212)",
								fill: "#f7e7f2"
							})
						]
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2972",
				"data-name": "Group 2972",
				transform: "translate(492.473 407.318)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_958",
						"data-name": "Rectangle 958",
						width: 7.002,
						height: 16.995,
						transform: "translate(24.737) rotate(90)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_959",
						"data-name": "Rectangle 959",
						width: 73.904,
						height: 130.554,
						transform: "translate(0 3.919)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_960",
						"data-name": "Rectangle 960",
						width: 1.281,
						height: 121.965,
						transform: "translate(66.4 8.213)",
						fill: "#b3b3cd"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_961",
						"data-name": "Rectangle 961",
						width: 53.323,
						height: 5.869,
						transform: "translate(6.631 13.337)",
						fill: "#b2eae4"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_962",
						"data-name": "Rectangle 962",
						width: 53.323,
						height: 5.869,
						transform: "translate(6.631 24.031)",
						fill: "#b2eae4"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_963",
						"data-name": "Rectangle 963",
						width: 53.323,
						height: 5.869,
						transform: "translate(6.631 34.725)",
						fill: "#b2eae4"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_964",
						"data-name": "Rectangle 964",
						width: 53.323,
						height: 5.869,
						transform: "translate(6.631 45.419)",
						fill: "#b2eae4"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_965",
						"data-name": "Rectangle 965",
						width: 53.323,
						height: 5.869,
						transform: "translate(6.631 56.112)",
						fill: "#b2eae4"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_966",
						"data-name": "Rectangle 966",
						width: 53.323,
						height: 5.869,
						transform: "translate(6.631 66.806)",
						fill: "#b2eae4"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_967",
						"data-name": "Rectangle 967",
						width: 53.323,
						height: 5.869,
						transform: "translate(6.631 77.5)",
						fill: "#b2eae4"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2973",
				"data-name": "Group 2973",
				transform: "translate(355.841 432.078)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_968",
						"data-name": "Rectangle 968",
						width: 10.516,
						height: 25.523,
						transform: "translate(29.781 3.127) rotate(90)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_969",
						"data-name": "Rectangle 969",
						width: 7.002,
						height: 16.995,
						transform: "translate(25.516) rotate(90)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_970",
						"data-name": "Rectangle 970",
						width: 34.038,
						height: 103.7,
						transform: "translate(0 6.013)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_971",
						"data-name": "Rectangle 971",
						width: 34.038,
						height: 1.862,
						transform: "translate(0 10.68)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_972",
						"data-name": "Rectangle 972",
						width: 1.281,
						height: 34.038,
						transform: "translate(0 13.182) rotate(-90)",
						fill: "#9bbdd3"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_973",
						"data-name": "Rectangle 973",
						width: 1.281,
						height: 34.038,
						transform: "translate(0 15.753) rotate(-90)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2514",
						"data-name": "Path 2514",
						d: "M873.464,941.968h-6.571v-6.822a3.286,3.286,0,0,1,3.286-3.286h0a3.286,3.286,0,0,1,3.286,3.286Z",
						transform: "translate(-843.126 -910.387)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Rectangle_974",
						"data-name": "Rectangle 974",
						d: "M3.286,0h0A3.286,3.286,0,0,1,6.571,3.286v6.821a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.286A3.286,3.286,0,0,1,3.286,0Z",
						transform: "translate(13.319 21.474)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2515",
						"data-name": "Path 2515",
						d: "M873.464,1024.705h-6.571v-6.822a3.286,3.286,0,0,1,3.286-3.286h0a3.285,3.285,0,0,1,3.286,3.286Z",
						transform: "translate(-843.126 -978.694)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Rectangle_975",
						"data-name": "Rectangle 975",
						d: "M3.286,0h0A3.286,3.286,0,0,1,6.571,3.286v6.821a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.286A3.286,3.286,0,0,1,3.286,0Z",
						transform: "translate(13.319 35.904)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2516",
						"data-name": "Path 2516",
						d: "M873.464,1107.441h-6.571v-6.822a3.286,3.286,0,0,1,3.286-3.286h0a3.285,3.285,0,0,1,3.286,3.286Z",
						transform: "translate(-843.126 -1047)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Rectangle_976",
						"data-name": "Rectangle 976",
						d: "M3.286,0h0A3.286,3.286,0,0,1,6.571,3.286v6.821a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.286A3.286,3.286,0,0,1,3.286,0Z",
						transform: "translate(13.319 50.334)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2517",
						"data-name": "Path 2517",
						d: "M873.464,1190.177h-6.571v-6.821a3.286,3.286,0,0,1,3.286-3.286h0a3.286,3.286,0,0,1,3.286,3.286Z",
						transform: "translate(-843.126 -1115.306)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Rectangle_977",
						"data-name": "Rectangle 977",
						d: "M3.286,0h0A3.286,3.286,0,0,1,6.571,3.286v6.821a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.286A3.286,3.286,0,0,1,3.286,0Z",
						transform: "translate(13.319 64.764)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2518",
						"data-name": "Path 2518",
						d: "M873.464,1272.913h-6.571v-6.822a3.286,3.286,0,0,1,3.286-3.286h0a3.286,3.286,0,0,1,3.286,3.286Z",
						transform: "translate(-843.126 -1183.612)",
						fill: "#f7e7f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Rectangle_978",
						"data-name": "Rectangle 978",
						d: "M3.286,0h0A3.286,3.286,0,0,1,6.571,3.286v6.821a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.286A3.286,3.286,0,0,1,3.286,0Z",
						transform: "translate(13.319 79.194)",
						fill: "#f7e7f2"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2974",
				"data-name": "Group 2974",
				transform: "translate(300.83 484.13)",
				children: [
					/* @__PURE__ */ _jsx("circle", {
						id: "Ellipse_85",
						"data-name": "Ellipse 85",
						cx: 19.428,
						cy: 19.428,
						r: 19.428,
						transform: "translate(0 27.475) rotate(-45)",
						fill: "#ec6786"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_979",
						"data-name": "Rectangle 979",
						width: .994,
						height: 26.948,
						transform: "translate(27.961 57.661) rotate(180)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_980",
						"data-name": "Rectangle 980",
						width: .994,
						height: 6.468,
						transform: "translate(31.738 38.264) rotate(45)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_981",
						"data-name": "Rectangle 981",
						width: .994,
						height: 6.468,
						transform: "translate(22.51 44.71) rotate(-45)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_982",
						"data-name": "Rectangle 982",
						width: .994,
						height: 6.468,
						transform: "translate(22.51 34.312) rotate(-45)",
						fill: "#2e2b60"
					})
				]
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_2975",
				"data-name": "Group 2975",
				transform: "translate(553.64 530.934)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_2519",
					"data-name": "Path 2519",
					d: "M1888.084,1379.023a7.338,7.338,0,0,0-3.708,1,10.856,10.856,0,0,0-19.644,6.373h30.727A7.375,7.375,0,0,0,1888.084,1379.023Z",
					transform: "translate(-1864.731 -1375.541)",
					fill: "#b6d5ef"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_2976",
				"data-name": "Group 2976",
				transform: "translate(608.011 532.573)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_2520",
					"data-name": "Path 2520",
					d: "M2200.353,1388.457a5.671,5.671,0,0,0-2.618.637,9.215,9.215,0,0,0-14.971-.607,5.757,5.757,0,0,0-.592-.031,5.7,5.7,0,0,0-5.7,5.7h29.579A5.7,5.7,0,0,0,2200.353,1388.457Z",
					transform: "translate(-2176.473 -1384.937)",
					fill: "#ec6786"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2977",
				"data-name": "Group 2977",
				transform: "translate(422.249 496.651)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2521",
						"data-name": "Path 2521",
						d: "M1128.383,1178.974l-17,45.14h34.005Z",
						transform: "translate(-1111.38 -1178.974)",
						fill: "#b6d5ef"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_983",
						"data-name": "Rectangle 983",
						width: .994,
						height: 26.948,
						transform: "translate(16.506 18.192)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_984",
						"data-name": "Rectangle 984",
						width: .994,
						height: 6.468,
						transform: "matrix(-0.707, -0.707, 0.707, -0.707, 12.728, 26.103)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_985",
						"data-name": "Rectangle 985",
						width: .994,
						height: 6.468,
						transform: "translate(12.728 37.59) rotate(-135)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_986",
						"data-name": "Rectangle 986",
						width: .994,
						height: 6.468,
						transform: "translate(21.957 31.143) rotate(135)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_987",
						"data-name": "Rectangle 987",
						width: .994,
						height: 6.468,
						transform: "translate(21.957 41.541) rotate(135)",
						fill: "#2e2b60"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2978",
				"data-name": "Group 2978",
				transform: "translate(486.903 502.908)",
				children: [
					/* @__PURE__ */ _jsx("circle", {
						id: "Ellipse_86",
						"data-name": "Ellipse 86",
						cx: 15.226,
						cy: 15.226,
						r: 15.226,
						transform: "translate(0 0)",
						fill: "#e7e7ec"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_988",
						"data-name": "Rectangle 988",
						width: .779,
						height: 21.12,
						transform: "translate(15.607 38.884) rotate(180)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_989",
						"data-name": "Rectangle 989",
						width: .779,
						height: 5.069,
						transform: "translate(18.567 23.681) rotate(45)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_990",
						"data-name": "Rectangle 990",
						width: .779,
						height: 5.069,
						transform: "translate(11.334 28.734) rotate(-45)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_991",
						"data-name": "Rectangle 991",
						width: .779,
						height: 5.069,
						transform: "matrix(0.707, -0.707, 0.707, 0.707, 11.334, 20.584)",
						fill: "#2e2b60"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2979",
				"data-name": "Group 2979",
				transform: "translate(507.224 502.908)",
				children: [
					/* @__PURE__ */ _jsx("circle", {
						id: "Ellipse_87",
						"data-name": "Ellipse 87",
						cx: 15.226,
						cy: 15.226,
						r: 15.226,
						transform: "translate(0 0)",
						fill: "#e7e7ec"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_992",
						"data-name": "Rectangle 992",
						width: .779,
						height: 21.12,
						transform: "translate(15.607 38.884) rotate(180)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_993",
						"data-name": "Rectangle 993",
						width: .779,
						height: 5.069,
						transform: "translate(18.567 23.681) rotate(45)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_994",
						"data-name": "Rectangle 994",
						width: .779,
						height: 5.069,
						transform: "translate(11.334 28.734) rotate(-45)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_995",
						"data-name": "Rectangle 995",
						width: .779,
						height: 5.069,
						transform: "matrix(0.707, -0.707, 0.707, 0.707, 11.334, 20.584)",
						fill: "#2e2b60"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2522",
				"data-name": "Path 2522",
				d: "M1018.872,1385.792a10.856,10.856,0,0,0-19.644-6.373,7.374,7.374,0,0,0-11.083,6.373h30.728Z",
				transform: "translate(-587.389 -844.106)",
				fill: "#8693f7"
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_2980",
				"data-name": "Group 2980",
				transform: "translate(477.166 532.573)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_2523",
					"data-name": "Path 2523",
					d: "M1450.134,1388.457a5.671,5.671,0,0,0-2.618.637,9.214,9.214,0,0,0-14.97-.607,5.762,5.762,0,0,0-.593-.031,5.7,5.7,0,0,0-5.7,5.7h29.578A5.7,5.7,0,0,0,1450.134,1388.457Z",
					transform: "translate(-1426.254 -1384.937)",
					fill: "#2e2b60"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_2981",
				"data-name": "Group 2981",
				transform: "translate(333.069 496.651)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2524",
						"data-name": "Path 2524",
						d: "M617.061,1178.974l-17,45.14h34.005Z",
						transform: "translate(-600.058 -1178.974)",
						fill: "#8693f7"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_996",
						"data-name": "Rectangle 996",
						width: .994,
						height: 26.948,
						transform: "translate(16.506 18.192)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_997",
						"data-name": "Rectangle 997",
						width: .994,
						height: 6.468,
						transform: "translate(12.728 26.103) rotate(-135)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_998",
						"data-name": "Rectangle 998",
						width: .994,
						height: 6.468,
						transform: "matrix(-0.707, -0.707, 0.707, -0.707, 12.728, 37.59)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_999",
						"data-name": "Rectangle 999",
						width: .994,
						height: 6.468,
						transform: "matrix(-0.707, 0.707, -0.707, -0.707, 21.957, 31.143)",
						fill: "#2e2b60"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_1000",
						"data-name": "Rectangle 1000",
						width: .994,
						height: 6.468,
						transform: "matrix(-0.707, 0.707, -0.707, -0.707, 21.957, 41.541)",
						fill: "#2e2b60"
					})
				]
			})
		]
	})
});
export default SvgNoData;
